<template>
  <div>
    <TagsEditor
      new-tag-label="Add sector"
      :value="tagsValue"
      :options="sectorOptions"
      :allow-to-add-tags="canAddSector"
      @change="onTagsChange"
    >
      <template slot-scope="{ tag }">
        {{ tag | sectorLabel }}
      </template>
    </TagsEditor>
  </div>
</template>

<script>
import { getSectorChoices, sectorLabel } from 'services/sectors'
import TagsEditor from 'components/TagsEditor.vue'

export default {
  components: { TagsEditor },
  filters: { sectorLabel },
  props: {
    value: { type: Array },
  },
  data() {
    return {
      sectorOptions: getSectorChoices(),
    }
  },
  computed: {
    tagsValue() {
      return this.value || []
    },
    canAddSector() {
      return (this.value || []).length < 5
    },
  },
  methods: {
    onTagsChange(sectors) {
      console.log(' => new sectors:', sectors)
      this.$emit('input', sectors)
    },
    noop() {},
  },
}
</script>
